import { AnyAction, PayloadAction, createSlice } from "@reduxjs/toolkit";
import { EditorVariant, ExpressionData } from "../types";
import {
  changeFieldDefinitionProp,
  changeLayoutElementProp,
  changeLayoutExpressionAtLine,
  changeSchemaExpressionAtLine,
} from "./editorSlice";

type InitialState = {
  isEditing: boolean;
  isValid: boolean;
  expression: string;
  editedExpression: string;
  targetExpressionLine?: number;
  targetEditor?: EditorVariant;
  targetExpressionProp?: string;
};

const initialState: InitialState = {
  isEditing: false,
  isValid: true,
  expression: "",
  editedExpression: "",
};

export const expressionEditorSlice = createSlice({
  name: "ExpressionEditor",
  initialState,
  reducers: {
    editExpressionAtLine(state, action: PayloadAction<ExpressionData>) {
      state.expression = action.payload.content;
      state.editedExpression = action.payload.content;
      state.isEditing = true;
      state.targetEditor = action.payload.editorVariant;
      state.targetExpressionLine = action.payload.line;
    },
    editExpressionAtProp(
      state,
      action: PayloadAction<{
        content: string;
        targetProp: string;
        targetEditor: EditorVariant;
      }>
    ) {
      state.isEditing = true;
      state.expression = action.payload.content;
      state.editedExpression = action.payload.content;
      state.targetExpressionProp = action.payload.targetProp;
      state.targetEditor = action.payload.targetEditor;
    },
    updateExpression(state, action: PayloadAction<string>) {
      state.editedExpression = action.payload;
    },
    cancelEdition: (state) => {
      state.isEditing = false;
      state.expression = "";
      state.editedExpression = "";
      state.targetEditor = undefined;
      state.targetExpressionLine = undefined;
      state.targetExpressionProp = undefined;
    },
    setIsValid: (state, action: PayloadAction<boolean>) => {
      state.isValid = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action: AnyAction) => {
        return [
          changeLayoutElementProp.type,
          changeFieldDefinitionProp.type,
          changeLayoutExpressionAtLine.type,
          changeSchemaExpressionAtLine.type,
        ].includes(action.type);
      },
      (state) => {
        state.isEditing = false;
        state.expression = "";
        state.editedExpression = "";
        state.targetEditor = undefined;
        state.targetExpressionLine = undefined;
        state.targetExpressionProp = undefined;
      }
    );
  },
});

export const {
  editExpressionAtLine,
  editExpressionAtProp,
  updateExpression,
  cancelEdition,
  setIsValid,
} = expressionEditorSlice.actions;
